import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormHelperText,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import {
  Labeled,
  Loading,
  useListController,
  useNotify,
  useTranslate,
} from 'react-admin';
import { apiUrl, httpClient } from '../../utils/httpUtils';

export const SettingsList = () => {
  const t = useTranslate();
  const [loadingStates, setLoadingStates] = useState({});
  const notify = useNotify();
  const listContext = useListController();

  const dataItems = listContext.data && Object.values(listContext.data);

  const handleChange = (value, id) => {
    const newStates = [...dataItems];
    const objIndex = newStates.findIndex(element => element.id === Number(id));
    if (objIndex >= 0) {
      newStates[objIndex].val = value;
    }
  };

  const handleSave = id => {
    const elem = dataItems.find(element => element.id === Number(id));
    const body = { name: elem.name, val: elem.val };

    setLoadingStates(prev => ({ ...prev, [id]: true }));

    httpClient(`${apiUrl}/settings/${id}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
      .then(res => {
        setLoadingStates(prev => ({ ...prev, [id]: false }));
        if (res.status === 200) {
          notify('Configuración guardada');
        } else {
          notify('ra.notification.http_error', { type: 'warning' });
        }
      })
      .catch(() => {
        setLoadingStates(prev => ({ ...prev, [id]: false }));
        notify('ra.notification.http_error', { type: 'warning' });
      });
  };

  if (listContext.isLoading) {
    return <Loading />;
  }

  return (
    <Card sx={{ maxWidth: '900px', marginTop: '24px', padding: '24px 16px' }}>
      <CardContent>
        <Typography
          variant="h1"
          sx={{ textAlign: 'start', fontSize: '32px', fontWeight: '700' }}
        >
          {t('resources.settings.name')}
        </Typography>
        <ul style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {dataItems &&
            dataItems.map((item, i) => (
              <li
                key={i}
                style={{
                  listStyle: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {item.type === 'checkbox' ? (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      maxWidth: '500px',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <Box display="flex" flexDirection="column">
                      <Labeled
                        label={item.name}
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          '& .RaLabeled-label': {
                            fontWeight: 'bold',
                            fontSize: '14px',
                            margin: '8px 0',
                            minWidth: '170px',
                          },
                        }}
                      >
                        <Tooltip
                          title={
                            Number(item.val) > 0
                              ? 'Habilitado'
                              : 'Deshabilitado'
                          }
                          aria-label=""
                        >
                          <Switch
                            name={item.name}
                            type={item.type}
                            checked={Number(item.val)}
                            color="primary"
                            onChange={e =>
                              handleChange(e.target.checked, item.id)
                            }
                          />
                        </Tooltip>
                      </Labeled>
                      <FormHelperText>{item.helper_text || ''}</FormHelperText>
                    </Box>
                    <Box>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={loadingStates[item.id]}
                        onClick={() => handleSave(item.id)}
                      >
                        {loadingStates[item.id] && (
                          <CircularProgress size={18} thickness={2} />
                        )}
                        {t('ra.action.save')}
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'end',
                      maxWidth: '500px',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <Labeled
                      label={item.name}
                      sx={{
                        '& .RaLabeled-label': {
                          fontWeight: 'bold',
                          fontSize: '14px',
                          margin: '8px 0',
                          minWidth: '170px',
                        },
                      }}
                    >
                      <TextField
                        name={item.name}
                        value={item.val}
                        type={item.type}
                        multiline={item.type !== 'number'}
                        color="primary"
                        variant="standard"
                        helperText={item.helper_text || ''}
                        sx={{ width: '254px' }}
                        onChange={e => handleChange(e.target.value, item.id)}
                      />
                    </Labeled>
                    <Box>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={loadingStates[item.id]}
                        onClick={() => handleSave(item.id)}
                      >
                        {loadingStates[item.id] && (
                          <CircularProgress size={18} thickness={2} />
                        )}
                        {t('ra.action.save')}
                      </Button>
                    </Box>
                  </Box>
                )}
              </li>
            ))}
        </ul>
      </CardContent>
    </Card>
  );
};
